import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { layoutPreventivo } from "@/lib/preventivoLayout";

const TOGGLES = [
  ["mostra_ragione_sociale_logo", "Ragione sociale accanto al logo"], ["mostra_sito", "Sito accanto al logo"],
  ["mostra_indirizzo", "Indirizzo sede"], ["mostra_telefono", "Telefono"], ["mostra_email", "Email"], ["mostra_pec", "PEC"],
  ["mostra_piva", "P.IVA"], ["mostra_cf", "Codice fiscale"], ["mostra_rea", "REA"], ["mostra_sedi", "Sedi operative"],
  ["mostra_card_incluso", "Riquadri \"cosa è incluso\" (pacchetti)"],
];

// Impostazioni del layout preventivo: valgono per anteprima, PDF scaricato ed email.
export default function LayoutPreventivoSettings({ imp, setImp }) {
  const L = layoutPreventivo(imp.preventivo_layout);
  const set = (patch) => setImp({ ...imp, preventivo_layout: { ...L, ...patch } });
  const setCard = (i, k, v) => set({ card_incluso: L.card_incluso.map((c, j) => (j === i ? { ...c, [k]: v } : c)) });
  return (
    <div className="bg-white border border-zinc-200 rounded-lg p-5 space-y-4 lg:col-span-2" data-testid="layout-preventivo-section">
      <div>
        <h3 className="font-semibold">Layout del preventivo</h3>
        <p className="text-xs text-zinc-500 mt-1">Cosa appare nel preventivo. Vale per l'anteprima, il PDF scaricato e il PDF inviato via email, che sono sempre identici. I dati (nome, indirizzi, sedi…) si modificano in "Dati Azienda".</p>
      </div>
      <div>
        <Label className="text-xs font-semibold">Grandezza logo: {L.logo_altezza}px</Label>
        <input type="range" min="50" max="180" step="2" value={L.logo_altezza} onChange={(e) => set({ logo_altezza: Number(e.target.value) })} className="w-full accent-emerald-600" data-testid="layout-logo-altezza" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {TOGGLES.map(([k, lab]) => (
          <label key={k} className="flex items-center justify-between gap-3 border border-zinc-200 rounded px-3 py-2 text-sm">
            {lab}<Switch checked={!!L[k]} onCheckedChange={(v) => set({ [k]: v })} data-testid={`layout-${k}`} />
          </label>
        ))}
      </div>
      <div><Label className="text-xs font-semibold">Scritta sopra il numero preventivo</Label>
        <Input value={L.titolo_sopra} onChange={(e) => set({ titolo_sopra: e.target.value })} className="mt-1" data-testid="layout-titolo-sopra" /></div>
      <div><Label className="text-xs font-semibold">Testo introduttivo dei pacchetti</Label>
        <Textarea rows={2} value={L.intro_pacchetto} onChange={(e) => set({ intro_pacchetto: e.target.value })} className="mt-1 text-sm" data-testid="layout-intro-pacchetto" /></div>
      {L.mostra_card_incluso && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          {L.card_incluso.map((c, i) => (
            <div key={i} className="border border-zinc-200 rounded p-2 space-y-1">
              <Input value={c.titolo} onChange={(e) => setCard(i, "titolo", e.target.value)} className="h-8 text-xs font-semibold" data-testid={`layout-card-titolo-${i}`} />
              <Input value={c.testo} onChange={(e) => setCard(i, "testo", e.target.value)} className="h-8 text-xs" data-testid={`layout-card-testo-${i}`} />
            </div>
          ))}
        </div>
      )}
      <p className="text-[11px] text-zinc-500">Ricordati di premere "Salva" in alto.</p>
    </div>
  );
}
